'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

// The core pagination (navigation, mobile window, scroll): the alias resolves to this file.
import {
  Pagination as CorePagination,
  type PaginationProps,
} from '../../../node_modules/@eliadmin/core/src/components/ui/pagination';

export type { PaginationProps };

/**
 * SveTech pages (Key design „Stránkovanie“): 40 → 48 px squares with a 1 px #e6e8e2 border, the
 * current page yellow without the button shadow. The core picks the button variant per item
 * (`default` current, `secondary` page, `ghost` disabled arrow), so the look is set on `item`.
 */
const ITEM = cn(
  'size-10 border border-[#e6e8e2] bg-white p-1 text-[#14171a] shadow-none hover:border-[#c9cdc4] hover:bg-[#f2f3ef] md:size-12',
  'aria-[current=page]:border-[#f1c40f] aria-[current=page]:bg-[#f1c40f] aria-[current=page]:text-[#14171a] aria-[current=page]:hover:bg-[#f7d63e]',
  '[--svt-radius:12px] [&_svg]:size-5',
);

export function Pagination({ className, ...props }: PaginationProps) {
  return (
    <CorePagination {...props} className={{ ...className, item: cn(ITEM, className?.item) }} />
  );
}
